<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">

    <ng-container>
        <div class="d-flex flex-column justify-content-between w-100 p-0">
            <ul class="card-list-striped">
              <li class="bg-white flex-column p-0">
                <h2 class="subtitle d-flex w-100 mw-100">
                  <div class="w-100">PONTUAÇÃO SCORE</div>
                  <div class="text-secondary text-nowrap">
                    {{ consulta?.score || msgNull }}
                  </div>
                </h2>
                <div class="p-2">
                  <app-sinalizador-nivel [nivel]="consulta?.score_gauge" class="sinalizador-width sinalizador-compacto"></app-sinalizador-nivel>
                </div>
              </li>
          
              <li class="bg-white flex-column  p-0">
                <h2 class="subtitle d-flex w-100">
                  <div class="w-100">PROBABILIDADE DE INADIMPLÊNCIA</div>
                  <div class="text-secondary text-nowrap">
                    {{ consulta?.prob_inadimplencia || msgNull }}
                  </div>
                </h2>
                <div class="p-2">
                  <app-sinalizador-nivel [nivel]="consulta?.prob_inadimplencia_gauge" class="sinalizador-width sinalizador-compacto"></app-sinalizador-nivel>
                </div>
              </li>
            </ul>
        </div>
          
          <div class="d-flex flex-column w-100 mw-100 p-0">
            <ul class="card-list-striped">
              <li class="p-0 mw-100 w-100">
                <h2 class="subtitle w-100">
                  OBSERVAÇÕES
                </h2>
              </li>
            </ul>
            <div class="d-flex flex-column w-100 m-2">
              <div class="p-2 text-dark text-center text-uppercase f-14">
                {{ consulta?.esclarecimento || msgNull }}
              </div>
            </div>
        </div>
    </ng-container>
</app-card-consulta>